/* eslint-disable react/jsx-key */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import { Link } from "@quintype/components";
import get from "lodash/get";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BLOCKS,
  GIFT_SUBSCRIPTION_ALLOWED_OCCURRENCES,
  TEXT,
} from "../constants";
import { SubscriptionPlanGrid } from "../subscription-plan-grid";
import { buildGiftCheckoutPath } from "../subscription-plan-grid/utils";
import { SubscriptionHelper } from "../subscription-helpers";

import "./subscription-blocks.m.css";
import {
  COMPRESS_PARAMS_MEDIUM,
  COMPRESS_PARAMS_SMALL,
} from "../../../../image-constants";
// import { da } from "date-fns/locale";

// const hindiPlanIds = [1367, 338, 1369, 340, 4060, 4061];
// const englishIndianPlanIds = [338, 1369, 340, 1378, 343];
// enter plan ids like: [staging Disruptor planID, staging Game changer planID, prod Disruptor planID, prod Game changer planID ] in tha array below
const englishIndianYearlyPlanIds = [1369, 1378, 340, 343];
const englishIndianMonthlyPlanIds = [1367, 1376, 338, 341];
const englishOverseasMonthlyPlanIds = [1376, 341];
const englishOverseasYearlyPlanIds = [1378, 343];
// const hindiYearlyPlanIds = [1369, 1378, 340, 343];
// const hindiMonthlyPlanIds = [1367, 1376, 338, 341];
const hindiPlanIds = [4671, 4672]; // monthly and 6 month
const jointYearlyPlanIds = [4455, 4460, 4471, 4476];
const jointMonthlyPlanIds = [4453, 4457, 4474, 4478];
const jointOverseasYearlyPlanIds = [4456, 4460, 6257, 6259];
const jointOverseasMonthlyPlanIds = [4454, 4458, 6258, 4478];
// const jointOverseasYearlyPlanIds = [4456, 4460, 4472, 4475];
// const jointOverseasMonthlyPlanIds = [4454, 4458, 4473, 4477];

const PAPER_TRAIL_PREVIEW_LINK_RE =
  /<a href=['"][^'"]+['"]><i>Preview the first edition\.<\/i><\/a>/g;

const withoutPaperTrailPreview = (benefit) =>
  typeof benefit === "string"
    ? benefit.replace(PAPER_TRAIL_PREVIEW_LINK_RE, "")
    : benefit;

export const SubscriptionBlocks = (props) => {
  const [activeBtn] = useState("yearly");
  const userCountryInfo = useSelector((state) =>
    get(state, ["fetchUserCountry"], {
      country_code: "",
      country_name: "",
      country_code_alias: "",
      user_timezone: "",
    }),
  );
  // const { qt } = useSelector(state => state);
  // const authHost = qt && qt.config.publisher.publisher.auth_host;
  const userCountry = {
    country_code: userCountryInfo.country_code,
    country_name: userCountryInfo.country_name,
    country_code_alias: userCountryInfo.country_code_alias,
    user_timezone: userCountryInfo.user_timezone,
  };

  const member = useSelector((state) => get(state, ["member"], null));
  const [selectedBlocks, setSelectedBlocks] = useState([]);
  const [jointSelectedBlocks, setJointSelectedBlocks] = useState([]);
  // const [plans, setPlans] = useState("yearly");
  const [isHindi, setIsHindi] = useState(false);
  // const [customHelperGCText, setCustomHelperGCText] = useState(null);
  const [isDisruptor] = useState(false);
  // const [isIndian, setIsIndian] = useState(true);

  useEffect(() => {
    const updateToggleVisualState = (toggle, isActive) => {
      const bg = toggle.querySelector(".toggle-bg");
      const knob = toggle.querySelector(".toggle-knob");

      if (bg) {
        bg.style.backgroundColor = isActive ? "#4caf50" : "#ccc";
      }

      if (knob) {
        knob.style.left = isActive ? "24px" : "4px";
      }
    };

    const toggles = Array.from(document.querySelectorAll(".auto-renew-toggle"));

    const cleanupFns = toggles.map((toggle) => {
      const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const isActive = toggle.getAttribute("data-active") === "true";
        const newActive = !isActive;
        toggle.setAttribute("data-active", String(newActive));
        updateToggleVisualState(toggle, newActive);

        const recurringPlan = toggle.getAttribute("data-recurring-plan");
        const onetimePlan = toggle.getAttribute("data-onetime-plan");
        const activePlan = newActive ? recurringPlan : onetimePlan;
        const intent = toggle.getAttribute("data-intent");
        const isHindiVal = toggle.getAttribute("data-is-hindi") === "true";
        const authHostVal = toggle.getAttribute("data-auth-host");
        const isMember = toggle.getAttribute("data-is-member") === "true";
        const isRecurringVal =
          toggle.getAttribute("data-is-recurring") === "true";

        const parent = toggle.parentElement;
        if (!parent) {
          return;
        }

        const link = parent.querySelector("a");
        if (!link) {
          return;
        }

        const domain = isHindiVal ? "hindi" : "www";

        if (!isMember) {
          const checkoutUrl = `https://${domain}.newslaundry.com/subscription/checkout?intent=${intent}&plan=${activePlan}`;
          link.href = `${authHostVal}/user-login?callback-url=https://${domain}.newslaundry.com&redirect-url=${checkoutUrl}`;
          return;
        }

        if (!isRecurringVal) {
          link.href = `/subscription/checkout?intent=${intent}&plan=${activePlan}`;
        }
      };

      updateToggleVisualState(
        toggle,
        toggle.getAttribute("data-active") === "true",
      );
      toggle.addEventListener("click", handleClick);

      return () => toggle.removeEventListener("click", handleClick);
    });

    return () => cleanupFns.forEach((cleanup) => cleanup());
  }, [
    props.gift,
    member,
    userCountry.country_code,
    userCountry.country_code_alias,
  ]);

  useEffect(() => {
    setIsHindi(!!(global.location && global.location.host.includes("hindi")));
    if (
      userCountry.country_code === "IN" ||
      userCountry.country_code_alias === "IND"
      // false
    ) {
      // setIsIndian(true);
      const isHindiWeb =
        !!global.location && global.location.host.includes("hindi");
      // const isHindiWeb = true;

      if (isHindiWeb) {
        // console.log(BLOCKS);
        setSelectedBlocks(
          BLOCKS.filter(
            (block) =>
              block.planId !== 2033 && hindiPlanIds.includes(block.planId),
          ),
        );
        // if (activeBtn == "monthly") {
        //   setSelectedBlocks(
        //     BLOCKS.filter(
        //       (block) =>
        //         block.planId !== 2033 &&
        //         hindiMonthlyPlanIds.includes(block.planId)
        //     )
        //   );
        //   setJointSelectedBlocks(
        //     BLOCKS.filter(
        //       (block) =>
        //         block.planId !== 2033 &&
        //         jointMonthlyPlanIds.includes(block.planId)
        //     )
        //   );
        // } else {
        //   setSelectedBlocks(
        //     BLOCKS.filter(
        //       (block) =>
        //         block.planId !== 2033 &&
        //         hindiYearlyPlanIds.includes(block.planId)
        //     )
        //   );
        //   setJointSelectedBlocks(
        //     BLOCKS.filter(
        //       (block) =>
        //         block.planId !== 2033 &&
        //         jointYearlyPlanIds.includes(block.planId)
        //     )
        //   );
        // }
      } else {
        if (activeBtn === "monthly") {
          setSelectedBlocks(
            BLOCKS.filter(
              (block) =>
                block.planId !== 2033 &&
                englishIndianMonthlyPlanIds.includes(block.planId),
            ),
          );
          setJointSelectedBlocks(
            BLOCKS.filter(
              (block) =>
                block.planId !== 2033 &&
                jointMonthlyPlanIds.includes(block.planId),
            ),
          );
        } else {
          setSelectedBlocks(
            BLOCKS.filter(
              (block) =>
                block.planId !== 2033 &&
                englishIndianYearlyPlanIds.includes(block.planId),
            ),
          );
          setJointSelectedBlocks(
            BLOCKS.filter(
              (block) =>
                block.planId !== 2033 &&
                jointYearlyPlanIds.includes(block.planId),
            ),
          );
        }
      }
    } else {
      if (activeBtn === "monthly") {
        // console.log(
        //   BLOCKS.filter(
        //     (block) =>
        //       block.planId !== 2033 &&
        //       englishOverseasMonthlyPlanIds.includes(block.planId)
        //   )
        // );
        // console.log(
        //   BLOCKS.filter(
        //     (block) =>
        //       block.planId !== 2033 &&
        //       jointOverseasMonthlyPlanIds.includes(block.planId)
        //   )
        // );

        setSelectedBlocks(
          BLOCKS.filter(
            (block) =>
              block.planId !== 2033 &&
              englishOverseasMonthlyPlanIds.includes(block.planId),
          ),
        );
        setJointSelectedBlocks(
          BLOCKS.filter(
            (block) =>
              block.planId !== 2033 &&
              jointOverseasMonthlyPlanIds.includes(block.planId),
          ),
        );
      } else {
        // console.log(
        //   BLOCKS.filter(
        //     (block) =>
        //       block.planId !== 2033 &&
        //       englishOverseasYearlyPlanIds.includes(block.planId)
        //   )
        // );
        // console.log(
        //   BLOCKS.filter(
        //     (block) =>
        //       block.planId !== 2033 &&
        //       jointOverseasYearlyPlanIds.includes(block.planId)
        //   )
        // );
        setSelectedBlocks(
          BLOCKS.filter(
            (block) =>
              block.planId !== 2033 &&
              englishOverseasYearlyPlanIds.includes(block.planId),
          ),
        );
        setJointSelectedBlocks(
          BLOCKS.filter(
            (block) =>
              block.planId !== 2033 &&
              jointOverseasYearlyPlanIds.includes(block.planId),
          ),
        );
      }
    }
    // console.log({ selectedBlocks }, { jointMonthlyPlanIds });
  }, [activeBtn, isDisruptor]);

  useEffect(() => {
    if (
      !userCountry.country_code === "IN" ||
      !userCountry.country_code_alias === "IN"
    ) {
      // setCustomHelperGCText("You save ₹300/month");
    }
    // console.log(selectedBlocks);
  }, [isHindi, selectedBlocks, jointSelectedBlocks]);

  return (
    <div styleName="wrapper" className="full-width">
      <div styleName={props.gift ? "top-gift-wrapper" : "top-wrapper"}>
        <h2 styleName="title">
          {props.custom
            ? "Grab our Republic Day offer now!"
            : !props.gift
            ? TEXT.subscriptionTitle
            : TEXT.giftTitle}
        </h2>

        {props.custom ? (
          <p styleName="helper-text">
            Buy a joint subscription to Newslaundry and The News Minute <br />
            and get free merchandise with every purchase: stickers, t-shirts,
            magnets and more.
            <br />
            Valid until January 27. Write to{" "}
            <a
              style={{ textDecoration: "underline", color: "#7676ff" }}
              href="mailto:subscription@newslaundry.com"
            >
              subscription@newslaundry.com
            </a>{" "}
            for any issues.
          </p>
        ) : (
          <p styleName="helper-text">
            {!props.gift ? TEXT.subscriptionDescription : TEXT.giftDescription}
          </p>
        )}
        {isHindi ? (
          <>
            <br />
            <br />
          </>
        ) : null}
      </div>

      {!props.gift ? (
        <>
          <SubscriptionPlanGrid
            member={member}
            intent="self_subscription"
            isHindi={isHindi}
            userCountry={userCountry}
          />
          {/* <p styleName="lower-text">
            <b>
              {" "}
              Reach out to us at{" "}
              <a
                href="mailto:subscription@newslaundry.com"
                style={{ color: "#ec2227" }}
              >
                subscription@newslaundry.com
              </a>{" "}
              for any issues related to your subscription.{" "}
            </b>
          </p> */}
          <div styleName={`feature odd`}>
            <img
              src={
                isHindi
                  ? `https://images.assettype.com/newslaundry/2024-07/a5b83d39-b54c-4ba1-9c44-aa80e0c28dc2/Hindi Sub page QR.png${COMPRESS_PARAMS_MEDIUM}`
                  : userCountry.country_code === "IN" ||
                    userCountry.country_code_alias === "IN"
                  ? `https://images.assettype.com/newslaundry/2024-04/83923e71-a99b-4bdd-85c1-213154a9b18f/Subscription_page_QR.png${COMPRESS_PARAMS_MEDIUM}`
                  : `https://images.assettype.com/newslaundry/2025-04-24/zeki9xhd/usd-plan-subscription-page-qr-code.png`
              }
              alt={"Scan this to pay"}
            />
            <div styleName="text-wrapper">
              <h3>
                {isHindi
                  ? "अब आप क्यूआर कोड स्कैन करके सीधे भुगतान कर सकते हैं"
                  : "Scan the QR code to pay directly"}
              </h3>
              {isHindi ? (
                <p>
                  खबरों के लिए भुगतान करना आसान और तेज़ होना चाहिए. यदि आप लॉगिन
                  और अन्य झंझटों से बचना चाहते हैं तो आप सीधे क्यूआर कोड स्कैन
                  कर सकते हैं या फिर यहां{" "}
                  <a href="https://razorpay.com/payment-button/pl_OZc02G2Pd7ErAt/view">
                    <u>क्लिक</u>
                  </a>{" "}
                  करके सीधे सदस्यता ले सकते हैं. बाकी का काम हम संभाल लेंगे.
                  आपके ईमेल पर सदस्यता संबंधी सारी जानकारी भेज दी जाएगी. क्यूआर
                  कोड के माध्यम से भुगतान करने के बाद, कृपया हमारी सदस्यता को
                  सक्रिय करने के लिए हमें कुछ घंटे का समय दें. धन्यवाद
                </p>
              ) : (
                <p>
                  Paying for news should be quick and easy. If you want to skip
                  login and other steps, you can scan the QR code or click{" "}
                  <a
                    href={
                      userCountry.country_code === "IN" ||
                      userCountry.country_code_alias === "IN"
                        ? "https://razorpay.com/payment-button/pl_O4RzISuNw9qaTC/view"
                        : "https://razorpay.com/payment-button/pl_QKQQSu2FAqgbkG/view"
                    }
                  >
                    <u>here</u>
                  </a>{" "}
                  to pay for subscription directly. We will take care of the
                  rest and email you the subscription details. Once you have
                  paid via the QR code, please give us a few hours to activate
                  your subscription.
                </p>
              )}
            </div>
          </div>
        </>
      ) : (
        <GiftBlocks
          member={member}
          userCountry={userCountry}
          isHindi={isHindi}
        />
      )}
      <SubscriptionHelper {...props} gift={props.gift} />
    </div>
  );
};

// eslint-disable-next-line no-unused-vars
const Block = ({
  data,
  value,
  gift,
  member,
  intent = "",
  isHindi = false,
  customHelperDisruptorText,
  customHelperGCText,
  activeBtn = "yearly",
}) => {
  const isRecurring = useSelector((state) =>
    get(state, ["fetchSubscription", "isRecurring"], null),
  );
  const { fetchSubscription } = useSelector((state) => state);
  const { qt } = useSelector((state) => state);
  const authHost = qt && qt.config.publisher.publisher.auth_host;
  // console.log({ authHost });
  const handleBtnClick = () => {
    const obj = {
      event: "subscription_addToCart",
      subscription_category: "self_subscription",
      subscription_plan: `${data.groupName} - ${data.planName}`,
      price: data.price,
      usertype: member ? "logged in" : "logged out",
      subscribertype: fetchSubscription.isActive
        ? "subscriber"
        : "nonsubscriber",
      userID: member ? member.id : "null",
      subscriptionID: fetchSubscription.isActive
        ? fetchSubscription.items.find((sub) => sub.active === true).id
        : "null",
    };

    window.dataLayer.push(obj);

    isRecurring &&
      window.alert(
        "Oops!You already have a recurring subscription. Try sena, student or gift subscription.",
      );
  };

  const oldRedirectURL = new URL(
    `https://${
      isHindi ? "hindi" : "www"
    }.newslaundry.com/subscription/checkout`,
  );
  const searchParams = new URLSearchParams(oldRedirectURL.search);
  searchParams.append("intent", intent);
  searchParams.append("plan", data.planId);
  // console.log({ searchParams });

  const redirectURL = new URL(
    `${oldRedirectURL.origin}${
      oldRedirectURL.pathname
    }?${searchParams.toString()}`,
  );

  return (
    <div
      styleName={activeBtn === "monthly" || isHindi ? "block-monthly" : "block"}
    >
      {/* {customHelperGCText && <small>{customHelperGCText}</small>} */}
      {/* {customHelperDisruptorText &&
        (data.planId === 1367 || data.planId === 338) && (
          <small>{customHelperDisruptorText}</small>
        )} */}
      <h3 styleName="block-title">{data.groupName}</h3>
      <div styleName="price-duration-wrapper">
        <div styleName="price-wrapper">
          {data.originalPrice && (
            <span aria-label="actual price">
              <strike>{data.originalPrice}</strike>
            </span>
          )}
          <h2 styleName="price" aria-label="discounted price">
            &#8377;{data.price}
          </h2>
        </div>
        <div styleName="duration">
          <p>{data.planName}</p>
        </div>
      </div>
      {data.originalPrice ? (
        <div styleName="discount-wrapper">
          <p>&#8377; {+data.originalPrice - +data.price} off</p>
        </div>
      ) : (
        <div></div>
      )}
      {!gift && (
        <Link
          href={
            !member
              ? `${authHost}/user-login?callback-url=https://${
                  isHindi ? "hindi" : "www"
                }.newslaundry.com&redirect-url=${redirectURL.href}`
              : !isRecurring
              ? `/subscription/checkout?intent=${intent}&plan=${data.planId}`
              : ""
          }
        >
          <button onClick={handleBtnClick}>SUBSCRIBE NOW</button>
        </Link>
      )}
      <ul aria-label="plan benefits" styleName="benefits">
        {data.benefits.map((benefit, index) => {
          return (
            <li key={index}>
              <i
                className="material-icons"
                style={{
                  color: "var(--component-background-success-solid-default)",
                }}
              >
                check
              </i>
              <span
                dangerouslySetInnerHTML={{
                  __html: withoutPaperTrailPreview(benefit),
                }}
              />
            </li>
          );
        })}
        {/* {data.plus && (
          <p styleName="plus-wrapper">
            <span styleName="plus-left-border"></span>
            <span>PLUS</span>
            <span styleName="plus-right-border"></span>
          </p>
        )} */}
        {data.plus &&
          data.plus.map((benefit, index) => {
            return (
              <li key={index}>
                <i
                  className="material-icons"
                  style={{
                    color: "var(--component-background-success-solid-default)",
                  }}
                >
                  check
                </i>
                <span
                  dangerouslySetInnerHTML={{
                    __html: withoutPaperTrailPreview(benefit),
                  }}
                />
              </li>
            );
          })}
      </ul>
    </div>
  );
};

// eslint-disable-next-line no-unused-vars
const JointBlock = ({
  data,
  setIsDisruptor,
  isDisruptor,
  value,
  gift,
  member,
  intent = "",
  isHindi = false,
  isHighlighted = false,
  customHelperDisruptorText,
  customHelperGCText,
}) => {
  // console.log({ data }, "data");
  const isRecurring = useSelector((state) =>
    get(state, ["fetchSubscription", "isRecurring"], null),
  );
  const { qt } = useSelector((state) => state);
  const authHost = qt && qt.config.publisher.publisher.auth_host;
  const { fetchSubscription } = useSelector((state) => state);
  // useEffect(() => {
  //   console.log({ data });
  // }, []);

  const handleBtnClick = () => {
    const obj = {
      event: "subscription_addToCart",
      subscription_category: "self_subscription",
      subscription_plan: `${data.groupName} - ${data.planName}`,
      price: data.price,
      usertype: member ? "logged in" : "logged out",
      subscribertype: fetchSubscription.isActive
        ? "subscriber"
        : "nonsubscriber",
      userID: member ? member.id : "null",
      subscriptionID: fetchSubscription.isActive
        ? fetchSubscription.items.find((sub) => sub.active === true).id
        : "null",
    };

    window.dataLayer.push(obj);

    isRecurring &&
      window.alert(
        "Oops!You already have a recurring subscription. Try sena, student or gift subscription.",
      );
  };

  const oldRedirectURL = new URL(
    `https://${
      isHindi ? "hindi" : "www"
    }.newslaundry.com/subscription/checkout`,
  );
  const searchParams = new URLSearchParams(oldRedirectURL.search);
  searchParams.append("intent", intent);
  searchParams.append("plan", data.planId);

  const redirectURL = new URL(
    `${oldRedirectURL.origin}${
      oldRedirectURL.pathname
    }?${searchParams.toString()}`,
  );
  // console.log({ isHindi }, "hindi");
  return (
    <div styleName="joint-block-wrapper">
      {/* {data.displayName.toLowerCase().includes("disruptor annual") ? ( */}
      {isHighlighted ? (
        <div styleName="pricing-plan-tag">Most popular</div>
      ) : (
        <></>
      )}
      <div styleName="joint-block-1">
        <h3 styleName="joint-block-title">NL-TNM Joint Subscription</h3>
        <img
          styleName="grp-img"
          src={`https://images.assettype.com/newslaundry/2023-10/3fb73eb2-de53-4ec9-bf75-1ecc648ec14f/Frame_12__1_.png${COMPRESS_PARAMS_SMALL}`}
          alt="NL-TNM logo"
        />
        <div styleName="duration">
          <p>{data.displayName}</p>
        </div>
        {/* <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "10px",
            marginBottom: "20px",
            marginTop: "20px",
          }}
        >
          <p styleName={!isDisruptor ? "activeName" : "name"}>Disruptor</p>
          <label htmlFor="plan-toggle" styleName="toggle">
            <input
              styleName="toggle-input"
              type="checkbox"
              id="plan-toggle"
              onChange={() => {
                // console.log("hii");
                setIsDisruptor(!isDisruptor);
                // setPlans("monthly");
              }}
            />
            <VisuallyHidden>
              {`Currently selected ${
                isDisruptor ? "Disruptor" : "Game changer"
              }. Toggle to select ${
                isDisruptor ? "Game changer" : "Disruptor"
              }`}
            </VisuallyHidden>
            <span styleName="toggle-label" data-off="" data-on=""></span>
            <span styleName="toggle-handle"></span>
          </label>
          <p styleName={isDisruptor ? "activeName" : "name"}>Game Changer</p>
        </div> */}
        {/* {data.originalPrice ? ( */}
        {/* <div styleName="discount-wrapper">
          <p>Most Valuable</p>
        </div> */}
        {/* ) : (
        <div></div>
      )} */}
        {/* <hr style={{backgroundColor:"gray", height:"1px", border:"none", width:"110%", marginLeft:"-5%", marginTop:"-0.5rem"}}/> */}
      </div>

      <div styleName="joint-block-2">
        <div styleName="joint-price-duration-wrapper">
          <div styleName="price-wrapper">
            {data.originalPrice && (
              <span aria-label="Actual price">
                <strike>{data.originalPrice}</strike>
              </span>
            )}
            <h2 styleName="price" aria-label="discounted price">
              &#8377;{data.price}
            </h2>
          </div>

          {data.originalPrice ? (
            <div styleName="discount-wrapper">
              <p>&#8377; {+data.originalPrice - +data.price} off</p>
            </div>
          ) : (
            <div></div>
          )}
        </div>
        {!gift && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Link
              href={
                !member
                  ? `${authHost}/user-login?callback-url=https://${
                      isHindi ? "hindi" : "www"
                    }.newslaundry.com&redirect-url=${redirectURL.href}`
                  : !isRecurring
                  ? `/subscription/checkout?intent=${intent}&plan=${data.planId}`
                  : ""
              }
            >
              <button onClick={handleBtnClick}>SUBSCRIBE NOW</button>
            </Link>
          </div>
        )}
        <div
          className="auto-renew-toggle"
          data-recurring-plan={data.planId}
          data-onetime-plan={data.oneTimePlanId || data.planId}
          data-active="true"
          data-intent={intent}
          data-is-hindi={isHindi}
          data-auth-host={authHost}
          data-is-member={!!member}
          data-is-recurring={!!isRecurring}
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            marginTop: "20px",
            alignItems: "center",
            borderTop: "1px solid #e0e0e0",
            paddingTop: "20px",
            cursor: "pointer",
            userSelect: "none",
          }}
        >
          <span style={{ color: "#8e8e8e", fontSize: "16px" }}>
            Auto-renews{" "}
            {data.displayName.toLowerCase().includes("monthly")
              ? "monthly"
              : "yearly"}
          </span>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span style={{ color: "#8e8e8e", fontSize: "16px" }}>
              Auto-renew
            </span>
            <div
              className="toggle-track"
              style={{
                position: "relative",
                display: "inline-block",
                width: "44px",
                height: "24px",
              }}
            >
              <div
                className="toggle-bg"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "#4caf50",
                  transition: ".4s",
                  borderRadius: "34px",
                }}
              >
                <div
                  className="toggle-knob"
                  style={{
                    position: "absolute",
                    height: "16px",
                    width: "16px",
                    left: "24px",
                    bottom: "4px",
                    backgroundColor: "white",
                    transition: ".4s",
                    borderRadius: "50%",
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
        <ul styleName="joint-benefits" aria-label="plan benefits">
          {!!data.benefits.length &&
            data.benefits.map((benefit, index) => {
              return (
                <li key={`${benefit}--${index}-true`}>
                  <i
                    className="material-icons"
                    style={{
                      color: "green",
                    }}
                  >
                    check
                  </i>
                  <span>{withoutPaperTrailPreview(benefit)}</span>
                  {/* {benefit} */}
                </li>
              );
            })}
          {data.plus && (
            <p>
              <span style={{ color: "black" }}>PLUS</span>
            </p>
          )}
          {!!data.plus &&
            data.plus.map((benefit, index) => {
              return (
                <li key={index}>
                  <i
                    className="material-icons"
                    style={{
                      color:
                        "var(--component-background-success-solid-default)",
                    }}
                  >
                    check
                  </i>
                  <span>{withoutPaperTrailPreview(benefit)}</span>
                  {/* {benefit} */}
                </li>
              );
            })}
          {!!data.strikedBenefits.length &&
            data.strikedBenefits.map((benefit, index) => {
              return (
                <li key={`${benefit}--${index}-false`}>
                  <i
                    className="material-icons"
                    style={{
                      color: "red",
                    }}
                  >
                    close
                  </i>
                  <strike>
                    <span>{benefit}</span>
                  </strike>
                </li>
              );
            })}
        </ul>
      </div>
    </div>
  );
};

const GiftBlocks = ({ member, userCountry, isHindi }) => {
  const formRef = React.useRef(null);
  const [data, setData] = React.useState({
    sender_name: member && (member.name || member.userName || ""),
    recipient_name: "",
    recipient_email: "",
    message: "",
    subscription_details: {
      sub_details: "Disruptor Annual One-time",
      amount: 5499,
    },
  });
  const [error, setError] = React.useState(null);
  const { recipient_name, recipient_email, message } = data;
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevState) => ({ ...prevState, [name]: value }));
  };
  const handleGiftCheckout = (selectedPlan) => {
    if (!formRef.current || !formRef.current.reportValidity()) {
      return;
    }

    const giftData = {
      ...data,
      subscription_details: {
        sub_details: `${selectedPlan.groupName} ${selectedPlan.planName} ${
          selectedPlan.isRecurring ? "Recurring" : "One-time"
        }`,
        amount: Number(selectedPlan.price),
      },
    };

    try {
      if (!member) {
        window.location = `https://auth.newslaundry.com/user-login?callback-url=https://www.newslaundry.com&redirect-url=https://www.newslaundry.com/gift&intent=gift_subscription`;
        return true;
      }
      setData((currentData) => ({ ...currentData, loading: true }));
      window.localStorage.setItem("giftData", JSON.stringify(giftData));
      global.app.navigateToPage(
        dispatch,
        buildGiftCheckoutPath(selectedPlan.planId),
      );
    } catch (e) {
      console.log(e);
      setError(e);
    } finally {
      setData((currentData) => ({ ...currentData, loading: false }));
    }
  };

  return (
    <div styleName="gift-block-wrapper">
      <form
        ref={formRef}
        styleName="gift-form"
        onSubmit={(event) => event.preventDefault()}
      >
        <h2>Enter Recipient's Information</h2>
        <div styleName="form-group">
          <label styleName="text">Recipient's Name*</label>
          <input
            styleName="input-text"
            required
            value={recipient_name}
            id="recipient_name"
            type="text"
            placeholder="Name"
            name="recipient_name"
            onChange={handleChange}
          ></input>
        </div>
        <div styleName="form-group">
          <label styleName="text">Recipient's Email*</label>
          <input
            styleName="input-text"
            required
            value={recipient_email}
            id="recipient's email*"
            type="email"
            placeholder="Email"
            name="recipient_email"
            onChange={handleChange}
          ></input>
        </div>
        <div styleName="form-group">
          <label styleName="text">Send a message</label>
          <textarea
            styleName="input-text"
            value={message}
            id="message"
            type="textarea"
            placeholder="Message"
            name="message"
            onChange={handleChange}
          ></textarea>
        </div>
        <small>{error}</small>
      </form>

      <SubscriptionPlanGrid
        allowedOccurrences={GIFT_SUBSCRIPTION_ALLOWED_OCCURRENCES}
        member={member}
        intent="gift_subscription"
        isHindi={isHindi}
        userCountry={userCountry}
        onCheckout={handleGiftCheckout}
      />
    </div>
  );
};
